import { atom } from "recoil";

export const isHomePathState = atom<string>({
  key: "isHomePathState",
  default: "home", // 기본값: 변경 없음
});

export const mainBannerModalState = atom<{
  isOpen: boolean;
  isVisible: boolean;
}>({
  key: "mainBannerModalState",
  default: {
    isOpen: true, // 모달 열림 여부
    isVisible: true, // 모달 표시 여부
  },
});

export const haederLoginModalState = atom<{
  isOpen: boolean;
  isVisible: boolean;
}>({
  key: "haederLoginModalState",
  default: {
    isOpen: false, // 모달 열림 여부
    isVisible: false, // 모달 표시 여부
  },
});

export const previewHeaderLoginModalState = atom<{
  isOpen: boolean;
  isVisible: boolean;
}>({
  key: "previewHeaderLoginModalState",
  default: {
    isOpen: false, // 모달 열림 여부
    isVisible: false, // 모달 표시 여부
  },
});
